import { FREE_GROUP_KEYS } from 'getting-started-shared-tasks/gettingStartedGroupKeys';
import { ONBOARDING_SALES_FREE } from 'getting-started-shared-tasks/onboardingKeys';
import { ONBOARDING_VIEWS } from 'user-context/onboardingSettings';
import { SALES_SIGNUP } from '../constants/signupConstants';
import { HubletUrl } from '../utils/urls';
const salesExperiencesChecks = [{
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/set-up-crm/${portalId}/templates`,
      view: ONBOARDING_VIEWS.SALES,
      onboardingKey: ONBOARDING_SALES_FREE,
      groupKey: FREE_GROUP_KEYS.freeSalesView
    };
  },
  checks: [{
    signupType: SALES_SIGNUP
  }]
}];
export default salesExperiencesChecks;